import { parseZonedDateTime, ZonedDateTime } from '@internationalized/date';
import { format } from 'date-fns';

export const getCaseOrTime = (
  donorHospitalDate: string | null,
  donorHospitalTime: string | null,
  donorHospitalTimeZone: string | null,
): ZonedDateTime => {
  const formattedOrTime = format(new Date(`${donorHospitalDate} ${donorHospitalTime}`), `yyyy-MM-dd'T'HH:mm:ss`);

  return parseZonedDateTime(`${formattedOrTime}[${donorHospitalTimeZone}]`);
};
